"use client";
const FrameLayout = ({
  children
}) => {

  return (
    <div>
      <main className="flex bg-[#F5F7F9]">{children}</main>
    </div>
  );
};

export default FrameLayout;
